import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import "dayjs/locale/uk";
import { TIMEZONE } from "../constans";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale("uk");

/**
 * Факт ТО з початку календарного місяця до сьогодні (Київ) та прогноз кінця місяця:
 * total + (total / elapsedDays) * daysLeftAfterToday.
 * @param {Array} orders — наприклад ordersForReports (з live за сьогодні)
 * @param {Date|string} rangeStartDate — початок вибраного діапазону в звіті
 * @returns {object|null}
 */
export function computeMonthTurnoverBarModel(orders, rangeStartDate) {
    const nowKyiv = dayjs().tz(TIMEZONE);
    const rangeMonthStart = dayjs(rangeStartDate).tz(TIMEZONE).startOf("month");
    if (!nowKyiv.isSame(rangeMonthStart, "month")) return null;

    const monthStartStr = nowKyiv.startOf("month").format("YYYY-MM-DD");
    const todayYmd = nowKyiv.format("YYYY-MM-DD");
    const elapsedDays = nowKyiv.date();
    const daysInMonth = nowKyiv.daysInMonth();
    const remainingAfterToday = Math.max(0, daysInMonth - elapsedDays);

    let totalSoFar = 0;
    for (const o of orders) {
        const ymd = dayjs(o.created_at).tz(TIMEZONE).format("YYYY-MM-DD");
        if (ymd >= monthStartStr && ymd <= todayYmd) {
            totalSoFar += Math.floor(Number(o.grand_total) || 0);
        }
    }

    const avgDaily = elapsedDays > 0 ? totalSoFar / elapsedDays : 0;
    const avgDailyRounded = Math.round(avgDaily);
    const projectedMonthEnd = Math.round(totalSoFar + avgDaily * remainingAfterToday);
    const percentTowardProjection =
        projectedMonthEnd > 0 ? (totalSoFar / projectedMonthEnd) * 100 : 0;

    return {
        totalSoFar,
        projectedMonthEnd,
        avgDailyRounded,
        remainingDays: remainingAfterToday,
        elapsedDays,
        daysInMonth,
        percentTowardProjection,
        monthTitle: nowKyiv.format("MMMM YYYY"),
    };
}

/** Instagram (1,4), Сайт (9), шоурум Київ (10) — як у SOURCE_OPTIONS / dashboard. */
export const MONTH_TURNOVER_SOURCE_SEGMENTS = [
    { key: "instagram", label: "Instagram", emoji: "📷", sourceIds: [1, 4] },
    { key: "site", label: "Сайт", emoji: "🌐", sourceIds: [9] },
    { key: "showroom_kyiv", label: "Шоурум Київ", emoji: "🏪", sourceIds: [10] },
];
